// extracted by mini-css-extract-plugin
export default {"typing":"vlzlW","background":"isQJY","content":"_2yAam","wrapper":"gYMU6","member":"Mve76","separator":"_9ilbr"};